module.exports = __webpack_public_path__ + "static/arquitecta-bold-bf704b699cfbdfa51821d4cf7607f9e5.woff";